export function isBoolean(val: any) { return typeof val === "boolean" }
